import { getApiUrl } from "./index";

export const onCheckAuth = async (code: string, redirectUri: string) => {
  const url = getApiUrl();

  const response = await fetch(`${url}/api/auth`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ code, redirect_uri: redirectUri }),
  });
  const data = await response.json();
  if (data.code !== 200) {
    return { error: data.message };
  } else {
    return data.data;
  }
};

export const onGetUser = async (id_token: string | null) => {
  const url = getApiUrl();
  const response = await fetch(`${url}/api/user`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${id_token || localStorage.getItem("fellou.id_token")}`,
    },
  });
  const data = await response.json();
  if (data.code !== 200) {
    return { error: data.message };
  } else {
    return data.data;
  }
};
